/**
 * IMPORT INDIVIDUAL COMPONENTS AS NEEDED (RECOMMENDED):
 */
import * as Popper from "@popperjs/core"
import {
    // BaseComponent,
    // Alert,
    Button,
    // Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    // Popover,
    // ScrollSpy,
    Tab,
    // Toast,
    // Tooltip,
} from 'bootstrap'

/** SET WINDOW OBJECT FOR GLOBAL ACCESS: */
window.Popper = Popper;
// window.Alert = Alert;
window.Button = Button;
// window.Carousel = Carousel;
window.Collapse = Collapse;
window.Dropdown = Dropdown;
window.Modal = Modal;
window.Offcanvas = Offcanvas;
// window.Popover = Popover;
// window.Scrollspy = Scrollspy;
window.Tab = Tab;
// window.Toast = Toast;
// window.Tooltip = Tooltip;